export const EVENT_TYPE_EXTERNAL = "external";
export const EVENT_TYPE_INTERNAL = "internal";

export function isExternalEvent(event) {
  if (!event || Array.isArray(event) || typeof event !== "object") return false;
  return String(event.event_type || "")
    .trim()
    .toLowerCase() === EVENT_TYPE_EXTERNAL;
}

export function isInternalEvent(event) {
  return !isExternalEvent(event);
}

export function getTicketingUrl(event) {
  if (!event) return null;
  var url = event.ticketing_url;
  return url && String(url).trim() ? url : null;
}

export function isEventNotExpired(event) {
  if (!event || !event.end_date) return false;
  return new Date(event.end_date).getTime() >= new Date().getTime();
}

export function isComingSoon(event) {
  if (isExternalEvent(event)) return false;
  if (!event || !event.ticket_start_at) return false;
  return new Date(event.ticket_start_at).getTime() > new Date().getTime();
}

export function hasInternalTickets(event) {
  return isInternalEvent(event) && event && event.tickets && event.tickets.length > 0;
}

export function getTicketPrice(event) {
  if (isExternalEvent(event)) return null;
  if (event && event.tickets && event.tickets.length > 0) return event.tickets[0].price;
  return null;
}

/** Whether ticket CTA should be shown on event detail page. */
export function canShowTicketCta(event) {
  if (!event || !isEventNotExpired(event)) return false;
  if (isExternalEvent(event)) return !!getTicketingUrl(event);
  if (isComingSoon(event)) return false;
  return hasInternalTickets(event);
}

/** Whether ticket CTA should be shown on EventCard (listings / home carousel). */
export function canShowCardTicketCta(event, options) {
  var home = options && options.home;
  var price = options && options.price;
  if (!event || !isEventNotExpired(event)) return false;
  if (isExternalEvent(event)) return !!getTicketingUrl(event);
  if (isComingSoon(event)) return false;
  if (home === "home") return isInternalEvent(event);
  return isInternalEvent(event) && (hasInternalTickets(event) || price != null);
}

export function openExternalTicketing(event) {
  var url = getTicketingUrl(event);
  if (url) {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}

export function isValidEvent(event) {
  return event && !Array.isArray(event) && typeof event === "object" && event.name;
}

export function shouldRenderHomePageModal(event) {
  if (!isValidEvent(event)) return false;
  if (isExternalEvent(event)) return !!getTicketingUrl(event);
  return hasInternalTickets(event);
}

export function isHomePageExternalModal(event) {
  return shouldRenderHomePageModal(event) && isExternalEvent(event);
}

export function isHomePageInternalModal(event) {
  return shouldRenderHomePageModal(event) && !isExternalEvent(event);
}

export function shouldRenderTicketModal(event) {
  if (!isValidEvent(event)) return false;
  if (isExternalEvent(event)) return !!getTicketingUrl(event);
  return hasInternalTickets(event);
}
